module.exports = __webpack_public_path__ + "static/media/loading.749d1d92.svg";